module.exports = __webpack_public_path__ + "static/media/2012_mar_fl_hosp.b76fecf2.jpg";